import type { FilterCriteria } from '@openx/components-filters/lib/FiltersBar/types.ts';
import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';
import type { TFunction } from 'i18next';
import type { ExportTypeValue } from '../../../../../../../../modules/audiences/AudienceForm/constants.ts';
import type { AudienceForm } from '../../../../../../../../modules/audiences/AudienceForm/types.ts';
import type { ProviderMap } from '../../../hooks/useReferenceData.ts';
import type { SegmentFilters } from '../components/SegmentsList/types.ts';
import { AvailableFilters, getFiltersConfig } from '../filters/filtersConfig.ts';

const LookalikeVisibleFilters = [AvailableFilters.REACH, AvailableFilters.DATA_PROVIDER];
const SegmentVisibleFilters = [AvailableFilters.DATA_PARTNER, AvailableFilters.DATA_TYPE, AvailableFilters.CATEGORY];

export const createFiltersProviderConfig = (
  t: TFunction,
  filters: SegmentFilters,
  onFiltersChange: (value: SegmentFilters) => void,
  categories: string[],
  subCategories: string[],
  providers: ProviderMap,
  organizations: Record<string, string>,
  observableDirectProvider: AudienceForm['direct_audience_provider'],
  matchType: ExportTypeValue | null,
  isLookalike: boolean,
  hideDataTypeFilter: boolean,
  hideDataProviderFilter = false,
  hideReachFilter = false,
  hasOxpsSegments?: boolean
) => {
  const visibleFilters = isLookalike ? LookalikeVisibleFilters : SegmentVisibleFilters;

  return {
    filtersConfig: getFiltersConfig({
      t,
      categories,
      subCategories,
      providers,
      observableDirectProvider,
      matchType,
      isLookalike,
      hideDataTypeFilter,
      hideDataProviderFilter,
      hideReachFilter,
      organizations,
      hasOxpsSegments,
    }),
    visibleFilters,
    criteria: { filters } as AllTableCriteria<FilterCriteria>,
    disabledFilters: [],
    onFiltersChange,
  };
};
